import { OrderFilterContainer } from '../sharedStyles'
import { styled } from '@mui/material'
import { SearchField } from 'ComponentLibrary'

type OrderTitleFilterProps = {
    setFilter: (filter: string) => void
    defaultOrderTitleFilter?: string
    label?: string
}

export const OrderTitleFilter = ({ setFilter, defaultOrderTitleFilter, label = 'Auftrag suchen' }: OrderTitleFilterProps) => {
    return (
        <OrderFilterContainer>
            <StyledSearchField
                fullWidth
                label={label}
                defaultValue={defaultOrderTitleFilter}
                handleSearch={setFilter}
                debounceDelay={500}
            />
        </OrderFilterContainer>
    )
}

const StyledSearchField = styled(SearchField)`
    & .MuiInputBase-root {
        height: 39px;
    }
    & label {
        padding-right: 25px;
    }
`
